"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUMMY_RATE_CARD = {
    currency: "EUR",
    frequency: 1,
    frequencyCapping: undefined,
    info: undefined,
    priceOnRequest: false,
    targeting: undefined,
    validFrom: new Date().toISOString(),
    validThru: new Date().toISOString(),
    adFormats: [],
    contact: {
        firstName: "",
        lastName: "",
        title: "",
        postalCode: "",
        locality: "",
        streetAddress: "",
        phone: "",
        fax: "",
        mail: "",
        web: ""
    }
};
//# sourceMappingURL=DummyRateCard.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/DummyRateCard.js
// module id = 53
// module chunks = 0